import React from "react";

interface MenuProps {
  id: string;
  children: React.ReactNode;
}

export const Menu = React.forwardRef<HTMLUListElement, MenuProps>(
  ({ children, ...rest }, ref) => {
    return (
      <ul ref={ref} {...rest}>
        {children}
      </ul>
    );
  }
);

type HTMLElementProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLElement>,
  HTMLElement
>;

interface MenuHeaderProps extends HTMLElementProps {
  as?: "li" | "div";
  id: string;
}

export const MenuHeader: React.FC<MenuHeaderProps> = ({
  as = "li",
  children,
  ...rest
}) => {
  return React.createElement(as, {
    role: "presentation",
    className: "dropdown-header text-truncate px-3",
    children,
    ...rest,
  });
};
